import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryTemperatureImgTxtSectionColLeftCls: string;
			heHubPulsarsDiscoveryTemperatureImgTxtSectionColRightCls: string;
		}
	},

	slug: string
}

class Temperature extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Temperature Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryTemperatureImgTxtSectionColLeftCls || '', 'he_hub_pulsars_discovery_temperature', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryTemperatureImgTxtSectionColRightCls || '', 'he_hub_pulsars_discovery_temperature', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Temperature;